<template>
    <a
        :href="link"
        class="map-news-post"
        :class="{
            'map-no-image': noImage,
            'map-featured': featured,
        }"
        :data-topic="topic"
        @click.prevent="read_more"
    >
        <template v-if="!noImage">
            <lazy-img :src="get_image()" v-if="showImage" />
            <div v-else class="map-article-image-placeholder"></div>
        </template>
        <div class="map-article-info">
            <h2>{{ title }}</h2>
            <span class="map-article-date">{{ date }}</span>
            <p>{{ excerpt }}</p>
        </div>
    </a>
</template>

<script>
    import LazyImg from '@/components/LazyImg';

    export default
    {
        name: 'news-post',
        components:
        {
            LazyImg,
        },
        props:
        {
            featured: Boolean,
            noImage: Boolean,
            image: [String, Object],
            author: Object,
            title: String,
            topic: String,
            date: String,
            excerpt: String,
            link: String,
        },
        data()
        {
            return {
                showImage: true,
            };
        },
        watch: {
            image()
            {
                this.showImage = null;
                setTimeout(() => this.showImage = this.image);
            },
        },
        mounted()
        {
            this.showImage = !!this.image;
        },
        methods:
        {
            read_more()
            {
                this.$router.push(this.link);
            },
            get_image()
            {
                if (this.image && this.image.id)
                {
                    return process.env.VUE_APP_BACKEND_URL + 'api/files/' + this.image.id + '/400x400_crop';
                }
                else if (this.image)
                {
                    return this.image;
                }

                this.showImage = false;
            },
            get_author_picture()
            {
                if (this.author && this.author.image)
                {
                    return process.env.VUE_APP_BACKEND_URL + 'api/files/' + this.author.image.id;
                }
            },
        },
    }
</script>
